import ConfigService from "./ConfigService";
import it from "../assets/translations/it";
import en from "../assets/translations/en";
import es from "../assets/translations/es";

class TranslationStore {
    constructor() {
        this.translations = {
            it: it || {},
            en: en || {},
            es: es || {}
        };
    }

    t(key, language) {
        const lang = language || ConfigService.currentLanguage();

        if (this.translations[lang] && this.translations[lang][key]) {
            return this.translations[lang][key];
        } else return key;
    }

    translatable(item, language) {
        if (!item) return '';
        if (typeof item === 'string') return item;
        const lang = language || ConfigService.currentLanguage();
        return item[lang] ||
            (Object.values(item).length && Object.values(item)[0]) ||
            '';
    }
}

export let TranslateService = new TranslationStore();

export function translate(key, language) {
    return TranslateService.t(key, language);
}



// WEBPACK FOOTER //
// ./services/TranslateService.js